export const DECIMAL = "decimal";
export const CURRENCY = "currency";
export const ACCOUNTING = "accounting";
export const PERCENT = "percent";
export const SCIENTIFIC = "scientific";

export const CURRENCY_PLACEHOLDER = "$";
export const PERCENT_PLACEHOLDER = "%";
export const NUMBER_PLACEHOLDER = "n";

export const LIST_SEPARATOR = ";";
export const GROUP_SEPARATOR = ",";

export const POINT = ".";
export const EMPTY = "";

export const DEFAULT_LOCALE = "en";

